import { render, staticRenderFns } from "./PatientInformationView.vue?vue&type=template&id=5ca2b192&scoped=true&"
import script from "./PatientInformationView.vue?vue&type=script&lang=ts&"
export * from "./PatientInformationView.vue?vue&type=script&lang=ts&"
import style0 from "./PatientInformationView.vue?vue&type=style&index=0&id=5ca2b192&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca2b192",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/a/1/s/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VIcon,VLayout})
